import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export interface PostCreateTeacherCoursesByTemplatesRequest {
    templateIds: Array<number>;
}

export function postCreateTeacherCoursesByTemplates({ templateIds }:
                                                        PostCreateTeacherCoursesByTemplatesRequest): Promise<any> {
    const { apiPostCreateTeacherCoursesByTemplates } = apiConfig.getStaticUrls();

    return postFetch(apiPostCreateTeacherCoursesByTemplates, { template_ids: templateIds });
}
